import React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const BootcampLocationIcon: React.FC<SVGComponentProps> = ({
  width = 16,
  height = 16
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_bootcamp_location)">
        <path
          d="M3.33203 9.52428C2.09779 10.0688 1.33203 10.8275 1.33203 11.6667C1.33203 13.3236 4.3168 14.6667 7.9987 14.6667C11.6806 14.6667 14.6654 13.3236 14.6654 11.6667C14.6654 10.8275 13.8996 10.0688 12.6654 9.52428M11.9987 5.33337C11.9987 8.04251 8.9987 9.33337 7.9987 11.3334C6.9987 9.33337 3.9987 8.04251 3.9987 5.33337C3.9987 3.12423 5.78956 1.33337 7.9987 1.33337C10.2078 1.33337 11.9987 3.12423 11.9987 5.33337ZM8.66536 5.33337C8.66536 5.70156 8.36689 6.00004 7.9987 6.00004C7.63051 6.00004 7.33203 5.70156 7.33203 5.33337C7.33203 4.96518 7.63051 4.66671 7.9987 4.66671C8.36689 4.66671 8.66536 4.96518 8.66536 5.33337Z"
          stroke="#64748B"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_bootcamp_location">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </SVGUniqueID>
);

export { BootcampLocationIcon };
